import PropTypes from 'prop-types'
import React, { Component } from 'react'

class FocusNavigator extends Component {
  static propTypes = {
    children: PropTypes.node,
    onEnter: PropTypes.func,
    onTab: PropTypes.func,
    nextOnEnter: PropTypes.bool,
  }

  constructor() {
    super()
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  getItemsAndActiveIndex() {
    const items = this.getFocusableMenuItems()
    const activeIndex = items.indexOf(document.activeElement)
    return { items, activeIndex }
  }

  getFocusableMenuItems() {
    const node = this.wrapper
    return Array.from(node.querySelectorAll('[tabIndex="-1"]'))
  }

  handleKeyDown(event) {
    // Do nothing on meta keys
    if (event.shiftKey || event.metaKey || event.ctrlKey) {
      return
    }

    switch (event.keyCode) {
      case 9 /* Tab */:
        if (this.props.onTab) {
          this.props.onTab()
        }
        this.focusNext()
        event.preventDefault()
        break
      case 40 /* Arrow Down */:
        this.focusNext()
        event.preventDefault()
        break
      case 38 /* Arrow Up */:
        this.focusPrevious()
        event.preventDefault()
        break
      case 13 /* Enter */:
        const { onEnter, nextOnEnter } = this.props
        if (onEnter) {
          this.props.onEnter()
        }
        if (!onEnter || nextOnEnter) {
          this.focusNext()
        }
        event.preventDefault()
        break
      default:
        this.focusInput()
    }
  }

  focusInput() {
    const { items } = this.getItemsAndActiveIndex()
    if (items.length === 0) {
      return
    }
    const item = items.find(item => item.tagName === 'INPUT')
    if (item) {
      item.focus()
    }
  }

  focusNext() {
    const { items, activeIndex } = this.getItemsAndActiveIndex()
    if (items.length === 0) {
      return
    }
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1
    items[nextIndex].focus()
  }

  focusPrevious() {
    const { items, activeIndex } = this.getItemsAndActiveIndex()
    if (items.length === 0) {
      return
    }
    const prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1
    items[prevIndex].focus()
  }

  render() {
    return (
      <div
        className="width-full"
        ref={ref => (this.wrapper = ref)}
        onKeyDown={this.handleKeyDown}
      >
        {this.props.children}
      </div>
    )
  }
}

export default FocusNavigator
